export default [
    {
        name: "ownerId",
        label: "Client",
        type: "relation",
        collection: "organizations",
        entityName: "owner",
        fields: ["name"],
    },
    {
        name: "truckTypeIds",
        label: "Truck Type",
        type: "list",
        url: "/truck-types",
        filterValue: "alias",
        entityName: "truckType",
        include: false,
    },
    {
        name: "recurringType",
        label: "Type",
        type: "string",
    },
    {
        name: "trucksCount",
        label: "Trucks Count",
        type: "number",
    },
    {
        name: "workingDays",
        label: "Working Days",
        type: "number",
    },
    {
        name: "workingHoursPerDay",
        label: "Working Hours Per Day",
        type: "number",
    },
    {
        name: "kilometersCount",
        label: "Kilometers Count",
        type: "number",
    },
    {
        name: "helpersPrice",
        label: "Helpers Price",
        type: "number",
    },
    {
        name: "extraHourPrice",
        label: "Extra Hour Price",
        type: "number",
    },
    {
        name: "extraKilometerPrice",
        label: "Extra Kilometer Price",
        type: "number",
    },
    {
        name: "extraDayPrice",
        label: "Extra Day Price",
        type: "number",
    },
    {
        name: "overnightPrice",
        label: "Overnight Price",
        type: "number",
    },
    {
        name: "representativePrice",
        label: "Representative Price",
        type: "number",
    },
    {
        name: "createdAt",
        label: "Joined At",
        type: "date",
    },
];
